import React from "react";

import { formatDate } from "~/utils/heartRateFormatters";
import { HealthBreakdown } from "../Shared";

interface BodyTemperatureData {
  date: string;
  value: number;
}

interface HourlyBodyTemperatureData {
  datetime: string;
  hour: number;
  value: number;
}

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

interface BodyTemperatureBreakdownProps {
  selectedRange: TimeRange;
  filteredData: (BodyTemperatureData | HourlyBodyTemperatureData)[];
  breakdownTitle: string;
  loading: boolean;
  error: string | null;
}

export const BodyTemperatureBreakdown: React.FC<
  BodyTemperatureBreakdownProps
> = ({ selectedRange, filteredData, breakdownTitle, loading, error }) => {
  const getKey = (item: BodyTemperatureData | HourlyBodyTemperatureData, selectedRange: TimeRange) => {
    return selectedRange === "1d"
      ? (item as HourlyBodyTemperatureData).datetime
      : (item as BodyTemperatureData).date;
  };

  const getTimeDisplay = (item: BodyTemperatureData | HourlyBodyTemperatureData, selectedRange: TimeRange) => {
    return selectedRange === "1d"
      ? (item as HourlyBodyTemperatureData).hour + ":00"
      : formatDate((item as BodyTemperatureData).date, selectedRange);
  };

  const getValues = (item: BodyTemperatureData | HourlyBodyTemperatureData) => [
    {
      label: "Value",
      value: item.value,
      color: "#ffc6c6",
      unit: "°F",
    },
  ];

  return (
    <HealthBreakdown
      selectedRange={selectedRange}
      filteredData={filteredData}
      breakdownTitle={breakdownTitle}
      loading={loading}
      error={error}
      dataTypeLabel="Body Temperature Data"
      getKey={getKey}
      getTimeDisplay={getTimeDisplay}
      getValues={getValues}
      noDataMessage="No body temperature data available"
    />
  );
};
